import { Compass, Home } from "lucide-react";
import { Button, RouteLink, StatusPage } from "../../components/ui";
import { tokenStorage } from "../../utils/tokenStorage";

export const NotFound = () => {
  const homeTo = tokenStorage.getAccessToken() ? "/app" : "/";

  return (
    <StatusPage
      gradientAccent="via-muted/40"
icon={
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
          <Compass className="h-8 w-8 text-primary" />
        </div>
      }
      title="404"
      description="We couldn't find the page you requested. It may have been moved or no longer exists. If you believe this is an error, please contact support."
      actions={
        <RouteLink to={homeTo} className="block w-full">
          <Button size="lg" className="w-full">
            <Home className="mr-2 h-5 w-5" />
            Go Home
          </Button>
        </RouteLink>
      }
    />
  );
};
